<template>
  <router-view @getPermission="addPermission" />
</template>
<script>
import {
  rootRouter,
  adminRouter,
  examineeRouter,
  baseRouter
} from "@/router/router";
import {
  rootMenuConfig,
  adminMenuConfig,
  examineeMenuConfig
} from "@/router/menu";
import { storageUtil } from "@/utils";
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  mounted() {
    this.init();
  },
  computed: {
    ...mapGetters(["getUserRole"])
  },
  methods: {
    ...mapMutations(["SET_ROUTER_MENUS"]),
    ...mapActions(["getUserInfo", "setMenu"]),
    init() {
      var path = window.location.hash;
      var isBaseRouter = this.ifBaseRouter(path);
      var role = this.getUserRole;
      if (!isBaseRouter && role === undefined) {
        this.addPermission();
      }
    },
     addPermission() {
      //判断用户类型,根据用户类型动态添加路由、菜单
      var that = this;
       this.getUserInfo().then(res => {
        var { type = 1 } = res;
        var asyncRouter = [];
        var menu = [];
        if (type === 1) {
          asyncRouter = examineeRouter;
          menu = examineeMenuConfig;
        } else if (type === 2) {
          asyncRouter = adminRouter;
          menu = adminMenuConfig;
        } else if (type === 3) {
          asyncRouter = rootRouter;
          menu = rootMenuConfig;
        }
        // 添加全局匹配路由(如果没有匹配路由,就跳转404)
        asyncRouter = asyncRouter.concat([
          {
            path: "*",
            redirect: "/404"
          }
        ]);

        this.$router.addRoutes(asyncRouter);
        this.setMenu(menu);
        //存储用户类型,点击报名的时候需要用到
        storageUtil.add('type',type)
      });
    },
    ifBaseRouter(path) {
      var isBaseRouter = baseRouter.some(base => {
        var baseUrl = base.path;
        if (base.meta && base.meta.baseUrl) {
          baseUrl = base.meta.baseUrl;
        }
        return path.indexOf(baseUrl) > -1;
      });
      return isBaseRouter;
    }
  },
  watch: {
    $route(to, from) {
      //防止浏览器直接输入页面看到页面内容
      var isBaseRouter = this.ifBaseRouter(to.path);
      var role = this.getUserRole;
      if (!isBaseRouter && role === undefined) {
        this.addPermission();
      }
      //设置导航菜单
      const { matched = [] } = to;
      if (matched.length > 0) {
        this.SET_ROUTER_MENUS(matched);
      }
    }
  }
};
</script>
